var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"termly-embed","data-id":"59a77428-830d-42f9-b138-bca2544b5bda","data-type":"iframe"}})}
var staticRenderFns = []

export { render, staticRenderFns }